<div class="inner">
    <h3>{{ 'CHAPTERS' | translate }}</h3>
	<div class="interactivity-chapters" *ngIf="hasTimelineChapters">
		<div class="message info">
			{{ 'CHAPTERS_IN_INTERACTIVITY_WARNING' | translate }}
		</div>
		<div *ngIf="mediaclip?.timelines && mediaclip?.timelines[0]"><a class="button" [routerLink]="['/library/interactivity/' + mediaclip.timelines[0].id]">{{ 'EDIT_INTERACTIVITY' | translate }}</a></div>
		<div>
			<bb-button (click)="importFromInteractivity()" [hasPermission]="'root'">
				{{ 'IMPORT_INTERACTIVITY_CHAPTERS' | translate }} (root only)
			</bb-button>
		</div>
	</div>
	<div class="columns" *ngIf="!hasTimelineChapters && !loadingTimeline">
		<div class="column">
			<div class="chapter-list" *ngIf="modelValue?.length">
				<div class="chapter"
					*ngFor="let chapter of modelValue; let i = index; trackBy: trackByFn;"
					(focusin)="setActiveChapter(chapter)"
					[class.active]="activeChapterId === chapter.id"
					[class.double-chapter-time]="doubleChapterTimeRef[chapter.id]"
				>
					<div class="chapter-number">
						<span>#{{ (i < 9 ? '0' : '') + (i + 1) }}</span>
					</div>
					<!-- might use later -->
					<!-- <video *ngIf="previewAsset && defaultMediaAssetPath" (click)="playerApi?.seek(chapter.timeOffset)" class="preview-video" [src]="defaultMediaAssetPath + previewAsset.src" [currentTime]="chapter.timeOffset" preload
						[title]="'GO_TO_CHAPTER_TIME' | translate"
					></video> -->
					 <div class="time" [class.disabled]="i === 0">
						<bb-button
							[naked]="true"
							class="seek-button"
							(click)="chapter.timeOffset = currentTime; highlightChapter(chapter); onChange()"
							[disabled]="i === 0 || chapter.timeOffset === currentTime"
							[title]="'INSERT_CURRENT_TIME' | translate"
						>
							 <i class="far fa-clock"></i>
						</bb-button>
						<bb-timecode-editor
							[title]="doubleChapterTimeRef[chapter.id] ? ('CHAPTER_TIME_WITHIN_ONE_SECOND' | translate) : ''"
							[class.flash]="chapter.id === highlightId"
							[disabled]="i === 0"
							[inMatFormField]="true"
							[hideFrames]="true"
							[useMilliseconds]="true"
							[min]="0"
							[max]="mediaclip.length"
							[(ngModel)]="chapter.timeOffset"
							[name]="'chapter-time-' + i"
							(ngModelChange)="onChange($event)"
							(input)="onTimecodeInput($event)"
						></bb-timecode-editor>
					 </div>
					<input type="text" autoFocus [name]="'chapter-name-' + i" class="chapter-title"
						placeholder="Chapter Title" [(ngModel)]="chapter.title" (ngModelChange)="onChange()"
						(keydown.Enter)="addChapter()">
					<bb-button [naked]="true" (click)="removeChapter(i)" [title]="'REMOVE_CHAPTER' | translate" [disabled]="i === 0 && modelValue.length > 1">
						<i class="far fa-trash"></i>
					</bb-button>
					<div class="time-in-chapter" [title]="'ACTIVE_CHAPTER' | translate"
						[style.visibility]="currentTime >= chapter.timeOffset && (!modelValue[i + 1] || currentTime < modelValue[i + 1].timeOffset) ? 'visible': 'hidden'"
					>
						<i class="far fa-timer"></i>
					</div>
				</div>
			</div>
			<div>
				<bb-button class="add-chapter" (click)="addChapter()">
					{{ 'ADD_CHAPTER' | translate}}
				</bb-button>
			</div>
		</div>
		<div class="column">
			<div class="player-container">
				<bb-player
					(onPlayerCreated)="onPlayerCreated($event)"
					[mediaclip]="mediaclip" 
					[autoplay]="true"
					[playoutOverrides]="{
						controlBar: 'Show',
						aspectRatio: '16:9',
						autoMute: 'true',
						width: '100%',
						responsiveSizing: 'true',
						allowImageSequence:'false',
						fullScreen:'Hide'
					}"></bb-player>
			</div>
			<div class="controls" *ngIf="playerApi">
				<!-- <bb-button class="play-pause-button" (click)="playPause()" [title]="'PLAY_PAUSE' | translate">
					<i *ngIf="!isPlaying" class="far fa-play"></i>
					<i *ngIf="isPlaying" class="far fa-pause"></i>
				</bb-button> -->
				<bb-button  class="seek-button" (click)="seekFrame(-1)" [disabled]="currentTime === 0" [title]="'FRAME_BACK' | translate">
					<i class="fas fa-backward-step"></i>
				</bb-button>
				<bb-button class="seek-button" (click)="seekFrame(1)" [disabled]="currentTime >= mediaclip?.duration" [title]="'FRAME_FORWARD' | translate">
					<i class="fas fa-forward-step"></i>
				</bb-button>
				<bb-button class="add-chapter" (click)="addChapter(true)" [disabled]="currentTime < 0.5 && modelValue?.length">
					{{ 'ADD_CHAPTER_AT' | translate }} <strong>{{ displayTime }}</strong>
				</bb-button>
			</div>
		</div>
	</div>
</div>
